import type { TranslationDict } from '../en';

const es: TranslationDict = {
  'header.buy': 'Comprar',
  'header.sell': 'Vender',
  'spend.label': 'Gastas',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Recibes',
  'payment.label': 'Método de pago',
  'payment.select': 'Seleccionar',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Sin métodos de pago para este par',
  'wallet.label': 'Dirección de billetera',
  'wallet.placeholderBuy': 'Ingresa tu dirección de recepción',
  'wallet.placeholderSell': 'Ingresa tu dirección de envío',
  'wallet.validating': 'Validando dirección...',
  'wallet.invalid': 'Ingresa una dirección válida',
  'wallet.invalidServer': 'Dirección de billetera inválida',
  'cta.buy': 'Comprar {crypto}',
  'cta.sell': 'Vender {crypto}',
  'cta.gettingPrice': 'Obteniendo mejor precio...',
  'cta.processing': 'Procesando...',
  'footer.poweredBy': 'Desarrollado por ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Desglose de tasa',
  'rate.close': 'Cerrar',
  'rate.updatesIn': 'Tasa se actualiza en 00:{seconds}',
  'rate.noQuote': 'Sin cotización disponible',
  'rate.exchangeRate': 'Tasa de cambio',
  'rate.processingFee': 'Comisión de procesamiento',
  'rate.networkFee': 'Comisión de red',
  'rate.provider': 'Proveedor',
  'toast.orderCreated': 'Orden creada',
  'toast.redirecting': 'Redirigiendo al checkout...',
  'toast.orderFailed': 'Orden fallida',
  'toast.couldNotCreate': 'No se pudo crear la orden',
  'toast.quoteError': 'Error de cotización',
  'toast.noProviders': 'Sin proveedores',
  'toast.somethingWrong': 'Algo salió mal',
  'error.amountZero': 'El monto debe ser mayor a 0',
  'error.minAmountFiat': 'El monto mínimo es {min} {currency}',
  'error.minAmountCrypto': 'El monto mínimo es {min} {currency}',
  'error.noProviders': 'Sin proveedores disponibles para esta combinación',
  'error.currencyUnavailableBuy': 'Esta moneda no está disponible para compras',
  'error.currencyUnavailableSell': 'Esta moneda no está disponible para ventas',
  'parity.info': 'Se te cobrará por {receiveAmount} {crypto}, el resto hasta {spendAmount} {fiat} se acreditará a tu cuenta {partner}',
  'redirect.secureBadge': 'Pago seguro',
  'redirect.title': 'Continuar pago',
  'redirect.description': 'Serás redirigido a {gateway} para completar tu pago.',
  'redirect.countdown': 'Redirigiendo en {seconds}...',
  'redirect.openTab': 'Abrir ACH en nueva pestaña',
  'redirect.cancel': 'Cancelar',
  'checkout.noOrder': 'No se encontró la orden',
  'checkout.goBack': 'Volver',
  'checkout.expired': 'Checkout expirado',
  'checkout.expiredDesc': 'La sesión ha expirado. Inténtalo de nuevo.',
  'checkout.startOver': 'Empezar de nuevo',
  'checkout.cancel': 'Cancelar',
  'checkout.loading': 'Cargando checkout...',
  'checkout.iframeTitle': 'Checkout del proveedor',
  'checkout.widgetTitle': 'Checkout de pago',
  'checkout.unknownMethod': 'Método de checkout desconocido',
  'processing.default': 'Procesando tu orden...',
  'processing.pending': 'Esperando confirmación de pago...',
  'processing.active': 'Procesando tu transacción...',
  'processing.generic': 'Procesando...',
  'processing.checkingStatus': 'Verificando estado...',
  'processing.orderId': 'ID de orden',
  'processing.provider': 'Proveedor',
  'processing.amount': 'Monto',
  'processing.receiving': 'Recibiendo',
  'processing.network': 'Red',
  'processing.toAddress': 'Dirección destino',
  'processing.usuallyMinutes': 'Esto generalmente toma unos minutos.',
  'processing.safeToClose': 'Puedes cerrar esta página - te enviaremos un email cuando esté completo.',
  'complete.buyTitle': '¡Compra completada!',
  'complete.sellTitle': '¡Venta completada!',
  'complete.buyDesc': 'Tu {crypto} ha sido enviado a tu billetera.',
  'complete.sellDesc': 'Tu pago en {fiat} está siendo procesado.',
  'complete.amountBuy': 'Monto recibido',
  'complete.amountSell': 'Monto vendido',
  'complete.paidBuy': 'Monto pagado',
  'complete.paidSell': 'Monto del pago',
  'complete.network': 'Red',
  'complete.wallet': 'Billetera',
  'complete.transaction': 'Transacción',
  'complete.provider': 'Proveedor',
  'complete.orderId': 'ID de orden',
  'complete.completed': 'Completado',
  'complete.viewExplorer': 'Ver en explorador',
  'complete.done': 'Listo',
  'errorStep.failed': 'Pago fallido',
  'errorStep.cancelled': 'Orden cancelada',
  'errorStep.expired': 'Orden expirada',
  'errorStep.refunded': 'Orden reembolsada',
  'errorStep.unknown': 'Algo salió mal',
  'errorStep.failedBuy': 'Tu pago no pudo ser procesado. Inténtalo de nuevo o usa otro método de pago.',
  'errorStep.failedSell': 'Tu venta no pudo ser procesada. Inténtalo de nuevo.',
  'errorStep.cancelledBuy': 'Tu orden fue cancelada. No se procesó ningún pago.',
  'errorStep.cancelledSell': 'Tu venta fue cancelada. No se transfirió ningún cripto.',
  'errorStep.expiredBuy': 'Tu orden ha expirado. Inicia una nueva compra.',
  'errorStep.expiredSell': 'Tu orden ha expirado. Inicia una nueva venta.',
  'errorStep.refundedBuy': 'Tu pago ha sido reembolsado. Los fondos aparecerán en tu cuenta en 5-10 días hábiles.',
  'errorStep.refundedSell': 'Tu cripto ha sido devuelto. Los fondos aparecerán en tu billetera pronto.',
  'errorStep.genericDesc': 'Ocurrió un error inesperado. Inténtalo de nuevo.',
  'errorStep.orderId': 'ID de orden',
  'errorStep.tryAgain': 'Reintentar',
  'errorStep.startOver': 'Empezar de nuevo',
  'errorStep.return': 'Volver',
  'errorStep.needHelp': '¿Necesitas ayuda? Contacta ',
  'errorStep.reference': 'Referencia: {orderId}',
  'confirm.buyTitle': 'Confirmar compra',
  'confirm.sellTitle': 'Confirmar venta',
  'confirm.loading': 'Cargando...',
  'confirm.provider': 'Proveedor',
  'confirm.youPay': 'Pagas',
  'confirm.youSell': 'Vendes',
  'confirm.youReceive': 'Recibes',
  'confirm.wallet': 'Billetera',
  'confirm.network': 'Red',
  'confirm.refundAddress': 'Dirección de reembolso',
  'confirm.parityNote': 'El monto cobrado puede diferir. El resto hasta {amount} {crypto} se acreditará a tu cuenta {partner}.',
  'confirm.processing': 'Procesando...',
  'confirm.confirmPay': 'Confirmar y pagar',
  'confirm.confirmSell': 'Confirmar y vender',
  'confirm.payout': 'Pago en {currency}',
  'modal.selectFiat': 'Seleccionar moneda fiat',
  'modal.selectCrypto': 'Seleccionar criptomoneda',
  'modal.choosePayment': 'Elegir método de pago',
  'modal.selectCountry': 'Selecciona tu país',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popular',
  'modal.recommended': 'Recomendado',
  'modal.noCurrencies': 'No se encontraron monedas',
  'modal.noPaymentMethods': 'No se encontraron métodos de pago',
  'modal.noCountries': 'No se encontraron países',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Ubicación',
  'settings.darkMode': 'Modo oscuro',
  'settings.privacy': 'Política de privacidad',
  'settings.terms': 'Términos de uso',
  'settings.language': 'Idioma',
  // ─── Additional ───
  'modal.chooseRamp': 'Elegir Ramp',
  'modal.bestPrice': 'Mejor precio',
  'modal.noQuotes': 'No hay cotizaciones disponibles para esta solicitud',
  'modal.noProvidersFound': 'No se encontraron proveedores',
  'payment.unavailableFor': 'No hay métodos de pago disponibles para {currency}',
  'skeleton.poweredBy': 'Desarrollado por NowRamp',
  'error.createOrderFailed': 'Error al crear la orden',
  'errorStep.returnToMerchant': 'Volver al comercio',
  'confirm.cryptoOnNetwork': '{crypto} en {network}',
  'payment.name.card': 'Tarjeta',
  'payment.name.bankTransfer': 'Transferencia bancaria',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default es;
